// @ts-nocheck
import { useEffect } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

//import { selectCurrentUser } from '@app/redux/features/userSlice';

import Loading from '@shared/common/Loading';
import Outlet from '@shared/uikit/outlet';
import useTheme from '@app/hooks/useTheme';

const SecurityLayout = () => {
  const theme = useTheme();

  //return userData?.id ? <Outlet /> : goToLogin();
  //return <div className='dark:bg-black dark:text-white h-screen w-screen '>
  return (
    <div className="bg-[#141316] text-white h-screen w-screen ">
      <Outlet />
    </div>
  );
};

export default SecurityLayout;
